<script lang="ts" setup>
import { computed } from 'vue';
import { SmallBusinessEmployee } from '@/application/smallBusiness/domain/SmallBusinessEmployee';
import { Relationships } from '@/application/smallBusiness/domain/SmallBusinessRelationships';
import AddPersonButton from '@/quote/infrastructure/components/AddPersonButton.vue';
import { useSmallBusinessStore } from '@/application/smallBusiness/infrastructure/composition/useSmallBusinessStore';

const { smallBusinessStore, smallBusinessState } = useSmallBusinessStore();

const props = defineProps<{
  person: SmallBusinessEmployee
  personRelationship: keyof typeof Relationships;
}>();

const maxDependentAllowedMap = {
  [Relationships.Spouse.key]: 1,
  [Relationships.Child.key]: 10,
};

const buttonLabelMap = {
  [Relationships.Spouse.key]: 'Spouse',
  [Relationships.Child.key]: 'Child',
};

const showAddDependentButton = computed(() => {
  const person = smallBusinessState.value.application.applicants.find(applicant => applicant.id === props.person.id);
  if (!person) {
    return false;
  }
  const currentDependentsCount = person.dependents.filter(d => d.relationship === props.personRelationship).length;

  return currentDependentsCount < maxDependentAllowedMap[props.personRelationship];
});

const addPerson = (): void => {
  smallBusinessStore.addDependent(props.person, props.personRelationship);
};

</script>
<template>
  <AddPersonButton v-if="showAddDependentButton" :label="buttonLabelMap[props.personRelationship]" class="flex items-center space-x-1 py-1 my-2 sm:my-0 text-sm" icon="plus" @click="addPerson()" />
</template>
